const userApi = {
  // UPDATEPWD: 'CSVPA-China/api/user/updatepwd', //修改密码
  // GETUSERLISTBYPAGER: 'CSVPA-China/api/user/getListByPager', //员工列表
  // SAVEUSER: 'CSVPA-China/api/user/save', //增加员工
  // UPDATEUSER: 'CSVPA-China/api/user/update', //编辑员工
  // GETTEACHERLISTBYROL: 'CSVPA-China/api/user/getListByRole', //所有老师
  // GETLISTCLASSADVISER: 'CSVPA-China/api/user/getListClassAdviser', //所有班主任
  // CHANGEHEADER: 'CSVPA-China/api/user/headPortrait', //修改头像
  // DELETESTAFF: 'CSVPA-China/api/user/delete',
  // // GETLISTCLASSADVISER: 'CSVPA-China/api/user/getListClassAdviser', //查询全部班主任
  // COURSEGETLISTALL: 'CSVPA-China/api/course/getListAll' //所有课程查询
  GETUSERDATA: '/student/page', //获取用户分页数据
  DELECTUSER: '/student/delete', //删除用户
  ADDUSERSITEM: '/student/save', //添加用户
  UPDATEUSERITEM: '/student/update', //编辑用户
  GETUSERMATCH: '/matchAttendanceDo/getMatchesByStudentId', //查询用户身上得项目,
  changePassWord: '/user/resetPwd' //修改密码
}

export default userApi
